import AdAccount from '@/entities/AdAccount';
import AdMetric from '@/entities/AdMetric';
import Adset from '@/entities/Adset';
import BaseEntity from '@/entities/BaseEntity';
import Campaign from '@/entities/Campaign';
import Post from '@/entities/Post';

export default class Ad extends BaseEntity {
  _entityFields = {
    ad_account: AdAccount,
    campaign: Campaign,
    adset: Adset,
    post: Post,
    metric: AdMetric,
  };

  _entityArrayFields = {
    metrics: AdMetric,
  };

  id = '';
  platform = '';
  external_id = '';
  name = '';
  ad_account = null;
  campaign = null;
  adset = null;
  post = null;
  status = null;
  effective_status = null;
  metric = null;
  metrics = [];
  created_at = null;
  deleted_at = null;
  text = '';
  variation = null;
  created_with_ai = false;
  url = '';
  created_by_rule = null;
  creative_type = null;

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
